import React, { useEffect, useRef } from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

export default function Testimonials() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.15 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="testimonios" ref={ref} className="relative py-24 md:py-36" style={{ background: "#00101f" }}>
      <div className="max-w-[1100px] mx-auto px-5 md:px-10">
        <p className="reveal uppercase tracking-[0.35em] text-[12px] mb-4 text-center" style={{ color: "#e55b36" }}>{TESTIMONIALS.eyebrow}</p>
        <h2 className="reveal font-display font-semibold text-white text-[40px] md:text-[64px] leading-none mb-16 text-center">{TESTIMONIALS.heading}</h2>

        {TESTIMONIALS.items.map((t, i) => (
          <div key={i} className="reveal rounded-3xl p-9 md:p-14 relative" style={{ background: "#001d3f", border: "1px solid rgba(177,205,255,0.12)" }}>
            <Quote size={56} style={{ color: "#e55b36", opacity: 0.35 }} />
            <p className="font-display font-medium text-white text-[24px] md:text-[36px] leading-snug mt-6">{t.quote}</p>
            <div className="mt-9 flex items-center gap-4">
              <div className="h-14 w-14 rounded-full grid place-items-center font-display font-semibold text-[22px]" style={{ background: "#e55b36", color: "#fff" }}>
                {t.name.charAt(0)}
              </div>
              <div>
                <div className="font-display font-semibold text-white text-[18px]">{t.name}</div>
                <div className="text-[14px]" style={{ color: "#b1cdff" }}>{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
